import { useHistory, useLocation } from 'react-router';
import { useFlowsDispatch } from '../../../common/src/utils/globalVariables';
import { setLastPosition } from '../store/redux/slices/flowsMetaDataSlice';
import useFlowsHelper from './useFlowsHelper';

interface FlowsProgression {
  moveToPosition: (pos: number) => void;
  moveToGroup: (groupId: string) => void;
  moveToQuestionPage: (questionId: string) => void;
}

const useFlowsMove = (): FlowsProgression => {
  const history = useHistory();
  const { search } = useLocation();
  const flowsDispatch = useFlowsDispatch();
  const { flowsBaseURL, getGroupPosition, getGroupByQuestionId } =
    useFlowsHelper();

  const moveToPosition = (pos: number) => {
    flowsDispatch(setLastPosition(pos));
    history.replace({ pathname: `${flowsBaseURL}/${pos}`, search });
  };

  const moveToGroup = (groupId: string) => {
    const groupPos = getGroupPosition(groupId);
    moveToPosition(groupPos);
  };

  const moveToQuestionPage = (questionId: string) => {
    const group = getGroupByQuestionId(questionId);
    const groupPos = getGroupPosition(group.id);
    moveToPosition(groupPos);
  };

  return {
    moveToPosition,
    moveToGroup,
    moveToQuestionPage,
  };
};

export default useFlowsMove;
